import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { StylesProvider } from '@material-ui/core/styles';
import App from "./App";
import "./index.css";
import * as serviceWorker from './serviceWorker';
import storage from './utils/storage';

// ✅ Suprimir erro benigno do ResizeObserver (comum com drag & drop)
// Este erro não afeta a funcionalidade da aplicação
// Solução: Sobrescrever ResizeObserver para debounce as notificações
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // Usar requestAnimationFrame para evitar o erro de loop
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

// Em dev, limpar apenas cache do SW (não o registro) para permitir Web Push
if (process.env.NODE_ENV === 'development' && 'serviceWorker' in navigator && 'caches' in window) {
  caches.keys().then(cacheNames => {
    cacheNames.forEach(cacheName => caches.delete(cacheName));
  });
}

// ✅ Limpar localStorage expirado/desatualizado ao iniciar
storage.cleanExpired();
console.log('[App] localStorage limpo. Stats:', storage.getStats());

ReactDOM.render(
  <React.StrictMode>
    <StylesProvider injectFirst>
      <CssBaseline>
        <App />
      </CssBaseline>
    </StylesProvider>
  </React.StrictMode>,
  document.getElementById("root"),
  () => {
    if (typeof window.finishProgress === "function") {
      setTimeout(() => {
        window.finishProgress();
      }, 300);
    }
  }
);

// Service Worker em produção e desenvolvimento (necessário para Web Push)
serviceWorker.register();

// ✅ Limpar localStorage periodicamente (a cada 1 hora)
setInterval(() => {
  storage.cleanExpired();
}, 60 * 60 * 1000);
